"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AdjustedAmounts {
}
exports.AdjustedAmounts = AdjustedAmounts;
//# sourceMappingURL=AdjustedAmounts.js.map